export default "__VITE_ASSET__DxJK61RQ__"